import { render, staticRenderFns } from "./ArticleHistoryList.vue?vue&type=template&id=591c0cf3"
import script from "./ArticleHistoryList.ts?vue&type=script&lang=ts&external"
export * from "./ArticleHistoryList.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports